export const EMAIL = "madisongrams.dev@gmail.com";
export const GITHUB_LINK = "https://github.com/madisongrams";
export const LINKEDIN_LINK =
  "https://www.linkedin.com/in/madison-grams-a389b6100/";
